/**
 * @remarks Reviewers should confirm loading, error, and i18n paths when modifying this file.
 * @remarks Contributors should run client tests and production build before opening a PR.
 * @see Sonar quality gate — maintain comment density and low cyclomatic complexity.
 */
/**
 * @description Maintainability notes for Sonar and future contributors:
 * - Prefer small functions and hooks over monolithic components.
 * - Extract shared literals, styles, and helpers instead of copying blocks.
 * - Document non-obvious business rules with short comments or JSDoc tags.
 * - Keep API access in logic/ modules; keep UI state in hooks/components.
 * - Use stable React keys and memoized handlers in list-heavy views.
 * - Add or update unit tests when changing conditional flows or payments.
 */
/**
 * @fileoverview Grid of sector checkboxes for appointment registration certifications.
 * @module components/AppointmentRegistrationSections/Certifications/SectorCheckboxGrid
 */

import { chunkArray } from "../../../utils/appointmentRegistrationUtils.js";
import { CERTIFICATIONS_ITEMS_PER_ROW } from "../../../utils/certificationSectionUtils.js";

/** Builds a stable React key for a row of sector checkbox items. */
const buildSectorRowKey = (rowItems) =>
  rowItems.map((item) => item.value).join("-");

/**
 * @param {Object} props
 * @param {Array} props.availableSectors - Sectors the user may select
 * @param {Array} props.sectors - Currently selected sector entries
 * @param {Function} props.onToggle - Called with sector value when toggled
 * @param {Object} props.styles - CSS module class map
 */
const SectorCheckboxGrid = ({
  availableSectors,
  sectors,
  onToggle,
  styles,
}) =>
  chunkArray(availableSectors, CERTIFICATIONS_ITEMS_PER_ROW).map((rowItems) => (
    <div key={buildSectorRowKey(rowItems)} className={styles.checkboxRow}>
      {rowItems.map((sector) => (
        <div key={sector.value} className={styles.checkboxItem}>
          <input
            type="checkbox"
            id={sector.value}
            className={styles.checkbox}
            checked={sectors.some((entry) => entry.value === sector.value)}
            onChange={() => onToggle(sector.value)}
          />
          <label htmlFor={sector.value} className={styles.checkboxLabel}>
            {sector.label}
          </label>
        </div>
      ))}
    </div>
  ));

export default SectorCheckboxGrid;
